// Where one building stands on a step and on a chapter, in the words Steps 1 and 3 use.
import type { AmazonBuilding } from "../../api/hooks/useAmazonOverview";
import type { StoryStep } from "./blueprint";

/** Done or not applicable on ``b``: nothing more is needed for it. */
export const isSettled = (b: AmazonBuilding, id: string): boolean =>
  ["done", "not_applicable"].includes(b.steps[id]?.state ?? "");

export type Shown = "done" | "open" | "blocked" | "na" | "todo";

/** The building's state on ``id``, or null for a step no record answers. */
export const shownState = (b: AmazonBuilding, id: string): Shown | null => {
  if (id === "negotiate") {
    return b.steps.sppa.state === "done" ? "done" : "open";
  }
  const step = b.steps[id];
  if (!step) return null;
  switch (step.state) {
    case "done":
      return "done";
    case "open":
      return "open";
    case "blocked":
      return "blocked";
    case "not_applicable":
      return "na";
    default:
      return "todo";
  }
};

export interface ChapterProgress {
  state: "done" | "now" | "blocked" | "next";
  done: number;
  total: number;
}

/** How far the building has got through a chapter's steps that its record answers. */
export const chapterProgress = (
  b: AmazonBuilding,
  steps: StoryStep[],
  chapter: number,
): ChapterProgress => {
  const shown = steps
    .filter((s) => s.chapter === chapter && !s.hidden)
    .map((s) => shownState(b, s.id))
    .filter((k): k is Shown => k !== null && k !== "na");
  const done = shown.filter((k) => k === "done").length;
  const state =
    done === shown.length
      ? "done"
      : shown.includes("blocked")
        ? "blocked"
        : shown.includes("open") || done > 0
          ? "now"
          : "next";
  return { state, done, total: shown.length };
};
